import React, { useEffect, useState } from 'react';
import axios from '../../utils/axiosInstance';
import { useNavigate } from 'react-router-dom';

const EmailVerificationPage = () => {
  const [status, setStatus] = useState('pending'); // 'pending' | 'success' | 'error'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');

        if (!token) {
          setStatus('error');
          setMessage('Lien de vérification invalide ou manquant.');
          return;
        }

        const response = await axios.get(`/auth/verify-email?token=${token}`);

        setStatus('success');
        setMessage(response.data.message || 'Votre adresse e-mail a été vérifiée avec succès !');

        // Redirection vers la page de connexion après 3 secondes
        setTimeout(() => navigate('/login'), 3000);
      } catch (error) {
        setStatus('error');
        if (error.response?.data?.message) {
          setMessage(error.response.data.message);
        } else {
          setMessage('Erreur lors de la vérification. Veuillez réessayer.');
        }
      }
    };

    verifyEmail();
  }, [navigate]);

  const getMessageColor = () => {
    if (status === 'success') return 'green';
    if (status === 'error') return 'red';
    return 'black';
  };

  return (
    <div style={{
      maxWidth: '500px',
      margin: '50px auto',
      padding: '20px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      textAlign: 'center',
      fontFamily: 'Arial, sans-serif'
    }}>
      {status === 'pending' && <p>Vérification en cours...</p>}
      {(status === 'success' || status === 'error') && (
        <>
          <p style={{ color: getMessageColor() }}>{message}</p>
          {status === 'success' && (
            <p style={{ fontSize: '0.9rem', marginTop: '10px', color: '#666' }}>
              Redirection vers la page de connexion...
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default EmailVerificationPage;
